import React, { useContext, useState } from "react";

import backend from "../../../backend";
import AuthContext from "../../../AuthContext";

const validatePasswordRules = pwd => {
  if (!pwd) return "La password nueva es requerida";
  if (pwd.length < 12) return "La password nueva debe tener al menos 12 caracteres";
  if (!/[A-Z]/.test(pwd)) return "Falta al menos 1 mayúscula";
  if (!/[a-z]/.test(pwd)) return "Falta al menos 1 minúscula";
  if (!/\d/.test(pwd))    return "Falta al menos 1 número";
  return null;
};

const MyAccountPanel = () => {
  const authContext = useContext(AuthContext);
  const user = authContext?.user;

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword]         = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError]                     = useState(null);
  const [success, setSuccess]                 = useState(false);
  const [submitting, setSubmitting]           = useState(false);

  const validate = () => {
    if (!currentPassword) return "Ingresá tu password actual";
    const ruleErr = validatePasswordRules(newPassword);
    if (ruleErr) return ruleErr;
    if (newPassword !== confirmPassword) return "Las passwords nuevas no coinciden";
    if (newPassword === currentPassword) return "La password nueva no puede ser igual a la actual";
    return null;
  };

  const handleSubmit = async e => {
    e?.preventDefault?.();
    setError(null);
    setSuccess(false);
    const validationError = validate();
    if (validationError) { setError(validationError); return; }

    setSubmitting(true);
    try {
      await backend.post("user/me/change-password", {
        currentPassword,
        newPassword,
      });
      setSuccess(true);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      const msg = err?.response?.data?.error
               || err?.response?.data
               || err?.message
               || "Error al cambiar la password";
      setError(typeof msg === "string" ? msg : "Error al cambiar la password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: 480 }}>
      {/* Cabecera de cuenta */}
      <div style={{
        background: "#242424", border: "1px solid #2e2e2e",
        borderRadius: 8, padding: "14px 16px", marginBottom: 18,
      }}>
        <div style={{ fontSize: 11, color: "#aaa", textTransform: "uppercase", letterSpacing: 0.5 }}>
          Cuenta
        </div>
        <div style={{ fontSize: 13, color: "#fff", marginTop: 4, fontWeight: 500 }}>
          {user?.email || "—"}
        </div>
        <div style={{ fontSize: 11, color: "#cbd5e1", marginTop: 4 }}>
          {user?.firstName || user?.lastName ? `${user?.firstName || ""} ${user?.lastName || ""}`.trim() : null}
        </div>
        <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>
          Roles: {(user?.roles || []).join(", ") || "—"}
        </div>
      </div>

      {/* Form de cambio de password */}
      <form onSubmit={handleSubmit}>
        <div style={{
          fontSize: 12, fontWeight: 700, color: "#999",
          textTransform: "uppercase", letterSpacing: ".07em",
          margin: "0 0 10px",
        }}>
          Cambiar password
        </div>

        <div className="bini-field">
          <label>Password actual</label>
          <input
            className="bini-input"
            type="password"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            autoComplete="current-password"
            disabled={submitting}
          />
        </div>

        <div className="bini-field">
          <label>Password nueva</label>
          <input
            className="bini-input"
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            autoComplete="new-password"
            disabled={submitting}
          />
          <div style={{ fontSize: 10, color: "var(--bini-text-muted)", marginTop: 4 }}>
            Mínimo 12 caracteres, con al menos 1 mayúscula, 1 minúscula y 1 número.
          </div>
        </div>

        <div className="bini-field">
          <label>Confirmar password nueva</label>
          <input
            className="bini-input"
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            disabled={submitting}
          />
        </div>

        {error && (
          <div className="bini-warning" style={{ marginTop: 12 }}>
            <div className="t">⚠ {error}</div>
          </div>
        )}

        {success && (
          <div className="bini-success-box" style={{ marginTop: 12 }}>
            <div className="t">✓ Password actualizada</div>
            <div className="d">Tu nueva password queda activa para el próximo login.</div>
          </div>
        )}

        <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
          <button
            type="submit"
            className="bini-btn bini-btn-save"
            disabled={submitting}
          >
            {submitting ? "Guardando…" : "Cambiar password"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default MyAccountPanel;
